import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const TRANSACTION_HISTORIES_INFLOW = gql`
  query TransactionHistories(
    $where: UserUniqueInput
    $filter: TransactionHistoryFilter
    $sort: TransactionHistorySort
  ) {
    transactionHistories(where: $where, filter: $filter, sort: $sort) {
      data {
        status
        user {
          lastName
          firstName
          id
          userNumber
        }
        metaData {
          taxesApplied {
            type
            percentage
          }
        }
        createdAt
        type
        transactionNumber
        subscription {
          status
          subscriptionId
          couponDetails {
            couponAppliedStatus
            isCouponAppliedOnSubscriptionRenew
          }
          metaData {
            gstApplied
            gstPercentage
            isTrialPeriodExpired
            userDamageWaiverFeesApplied
            userTrialApplied
            priceBreakdown {
            basePrice
            membershipFees
            securityDeposit
            damageWaiverFees
            gstAmount
            couponCode
            couponPercent
            couponDiscount
            finalPrice
            proRataCredit
            rentalCredit
          }
            membershipData {
              isMembershipFee
              amount
            }
            isSecurityDeposit
            deviceType
            paymentProvider
            updatedBy {
              type
            }
          }
          coupon {
            name
            type
            value
          }
          subscriptionPlan {
            name
            type
            price
            slug
          }
          subscriptionFeatures {
            discount
            memberShipFees
            refundableDeposit
            totalKeepCountPerMonth
            effectiveCostPerMonth
            totalFreeDeliveryPerMonth
            bonusDeliveries
            actualChargesForDamageWaiverFees
            actualChargesForSecurityDeposit
            actualChargesForMemberShipFees
            damageWaiverFees
            damageWaiverFeesApplied
            membershipFeesApplied
            securityDepositApplied
            trialAmount
            trialApplied
            trialDays
            planVersion
          }
        }
        price
        id
      }
      count
    }
  }
`;

export const TRANSACTION_HISTORIES_OUTFLOW = gql`
  query TransactionHistories(
    $filter: TransactionHistoryFilter
    $sort: TransactionHistorySort
  ) {
    transactionHistories(filter: $filter, sort: $sort) {
      data {
        status
        metaData {
          carryForwardedTransactionData {
            transactionHistoryId
            transactionNumber
          }
          taxesApplied {
            type
            percentage
          }
        }
        comment
        reason
        transactionNumber
        user {
          lastName
          firstName
          id
          userNumber
        }
        createdAt
        paidOn
        type
        subscription {
          status
          subscriptionPlan {
            name
            type
            price
            slug
          }
          subscriptionFeatures {
            planVersion
          }
        }
        price
        id
      }
      count
    }
  }
`;

export const USERS = gql`
  query Users($filter: UsersFilter, $sort: UsersSort) {
    users(filter: $filter, sort: $sort) {
      data {
        firstName
        id
        lastName
        userNumber
      }
    }
  }
`;

export const TRANSACTION_HISTORIES_REFERRAL = gql`
  query TransactionHistories(
    $where: UserUniqueInput
    $filter: TransactionHistoryFilter
    $sort: TransactionHistorySort
  ) {
    transactionHistories(where: $where, filter: $filter, sort: $sort) {
      data {
        status
        user {
          lastName
          firstName
          id
          userNumber
        }
        metaData {
          taxesApplied {
            type
            percentage
          }
          referredUser {
            firstName
            lastName
            id
            userNumber
          }
          referredLibrary {
            id
            libraryNumber
            name
            referralCode
          }
        }
        createdAt
        type
        transactionNumber
        price
        id
      }
      count
    }
  }
`;
